import { IdName } from "./../types";
import { Container } from "./../types/container.type";
import { Filter } from "./../types/filter.type";
import { Pagination } from "./../types/pagination.type";
import { responseHandlerDefault } from "./../utils/handler.util";
import axios from "./api";

/**
 *
 */
export const getWebToken = () => {
  const config = {
    headers: {
      Accept: "application/json",
      "api-token": "biKcumv4YohfHjPWGwD_Ze3k62E6rw0XfjyjAlKzM0lGuSTW3ePfo-r9j2k-86i6dWk",
      "user-email": "alejandrorocampeloaquacorp@gmail.com",
    },
  };
  return axios.get("https://www.universal-tutorial.com/api/getaccesstoken", config);
};
export const getState = (authorization: string, country: string) => {
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${authorization}`,
    },
  };
  return axios
    .get(`https://www.universal-tutorial.com/api/states/${country}`, config)
    .then(responseHandlerDefault);
};
/**
 * get list of containers for the indicated page
 * @param skip
 * @param size
 * @returns
 */
export const getContainerPage = (
  page: number | undefined,
  size: number | undefined,
  filter?: Filter
): Promise<Pagination<Container>> => {
  const params: { page?: number; size?: number; filter?: Filter } = {};
  if (page) {
    params.page = page;
  }
  if (size) {
    params.size = size;
  }
  if (filter) {
    params.filter = filter;
  }

  return axios.get(`/container/page/`, { params }).then(responseHandlerDefault);
};

export const getAllContainer = async (filter?: Filter): Promise<Container[]> => {
  const data = await getContainerPage(undefined, undefined, filter);
  return data.data;
};

export const getContainerById = (containerId: number): Promise<Container> => {
  return axios.get(`/container/get/${containerId}`).then(responseHandlerDefault);
};

export const getContainerTypes = (): Promise<IdName[]> => {
  return axios.get("/container/container-types").then(responseHandlerDefault);
};

export const putContainer = (container: Container): Promise<Container> => {
  return axios.put(`/container/${container.id}`, container).then(responseHandlerDefault);
};

export const postContainer = (container: Container): Promise<Container> => {
  return axios.post(`/container/new`, container).then(responseHandlerDefault);
};

export const getContainerNames = (): Promise<IdName[]> => {
  return axios.get(`/container/names`).then(responseHandlerDefault);
};

export const changeActiveContainer = (containerId: number): Promise<Container> => {
  return axios.put(`/container/${containerId}/change_active`).then(responseHandlerDefault);
};

export const getContainerCoordinates = () => {
  return axios.get(`/container/coordinates`);
};
